module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div ng-cloak ng-if="pc.view == \'visitor\'">\n  <profile-visitor ng-clock pc="pc"></profile-visitor>\n</div>\n<div ng-cloak ng-if="pc.view != \'visitor\'">\n  <profile-home ng-cloak pc="pc"></profile-home>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./src/app/features/profile/index.html
// module id = 316
// module chunks = 0